<div
    class="flex flex-col gap-x-7.5 rounded-[10px] border border-malou-primary bg-white p-5 md:gap-2"
    [ngClass]="{
        '!rounded-[20px]': isScorePreview(),
        '!border-0 !bg-white/20': !!scoreRating(),
    }">
    <div class="malou-text-28--bold md:malou-text-14--bold text-malou-text-title">
        {{ restaurantName() }}
    </div>
    <div class="malou-text-12--regular md:malou-text-10--regular flex gap-x-4 text-malou-text-title md:flex-col">
        @if (restaurantAddress(); as restaurantAddress) {
            <div class="flex items-center gap-x-2">
                <mat-icon class="!h-4 !w-4 text-malou-primary md:!h-3 md:!w-3" [svgIcon]="SvgIcon.LETTER"></mat-icon>
                <span>{{ restaurantAddress }}</span>
            </div>
        }
        @if (instagramAccount()) {
            <div class="flex items-center gap-x-2">
                <img
                    class="h-5 w-5 rounded md:h-3 md:w-3"
                    alt="instagram logo"
                    [src]="
                        instagramProfilePictureUrl()
                            ? instagramProfilePictureUrl()
                            : (PlatformKey.INSTAGRAM | logoPathResolver: { folder: 'platforms' })
                    " />
                <span>{{ instagramAccount() }}</span>
            </div>
        }
    </div>
</div>
